export const definitionObject = obj => ({
  key: "definition",
  templateData: {
    definition: {
      name: obj?.workflowName,
      type: obj?.workflowType,
      ...(obj?.trigger && { entity: "lead" }),
      ...(obj?.triggerAction && { triggerAction: obj?.triggerAction }),
      sharedWithAllDepts: obj?.visibleToAll,
      ...(obj?.departments?.length && { teamTypeIds: obj.departments.join(",") }),
    },
  },
})
export const initiationObject = (obj, id) => ({
  key: "initiation",
  templateData: {
    initiation: {
      inputs: obj?.requiredFields,
      description: obj?.description,
      isLinkedWithEntity: obj?.isLinkedWithEntity || false,
      ...(obj?.isLinkedWithEntity && { fieldType: obj.fieldType }),
    },
  },
  templateId: id,
})

export const stagesObject = (obj, id) => ({
  key: "stages",
  templateData: {
    stages: obj?.map((item, index) => {
      let assigneeObj = {
        staffId: item?.staffId ? Number(item?.staffId) : -1,
        autoAssignToTeam: item?.autoAssign === "true",
        assignToRequestInitiator: item?.assignTo === "request_initiator",
        assignToPreviousStageAssignee: item?.assignTo === "previous_assignee",
        assignToLeadAllocatedUser: item?.assignTo === "allocated_user",
        assignToLeadSharedWithUser: item?.assignTo === "shared_user",
        ...(item?.assignTo === "shared_user" && { leadSharedWithTeamType: item?.sharedWithUser }),
        excludeTeamDesignations: item?.staffId != "-1" ? item?.excludeTeamDesignations?.join(",") : undefined,
      }
      let config = {
        allowBackStage: item?.allowBackStage === "true",
        allowTermination: item?.allowTermination === "true",
        turnAroundTime: item?.turnAroundTime,
        skippable: item?.skippable === "true",
        notificationMessage: item?.notificationMessage,
      }
      let inputs = item?.requiredFields
      return {
        name: item?.name,
        assignee: assigneeObj,
        config,
        inputs,
        description: item?.description,
        sortOrder: item.index,
        id: item?.stageId,
      }
    }),
  },
  templateId: id,
})
